module.exports = __webpack_public_path__ + "static/blueprint-d002b6a75f9405ca8d43f32902b9ff02.svg";